import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface IPazeSdk {
  canCheckout: Function;
  checkout: Function;
  complete: Function;
  initialize: (client:IPazeClient) => Promise<void>
};

interface IPazeClient {
  "client": {
    "id": string;
    "name": string;
    "profileId": string;
  }
};

@Injectable({
  providedIn: 'root'
})
export class PazeService {
  enable_paze = true;
  addedScript = false;
  sdkLoader = new Subject<IPazeSdk|null>();
  pazePaymentReceived$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor() {}

  addPazeScript() {
    if (!this.enable_paze && this.addedScript) return;

    const script = document.createElement('script');
    script.src = environment.pazeUrl;
    script.type = 'text/javascript';
    document.body.appendChild(script);

    this.addedScript = true;
    this.checkForLoading();
  };

  private checkForLoading() {
    let counter = 0;

    const interval = setInterval(() => {
      counter++;

      const sdk = (window as any)['DIGITAL_WALLET_SDK'];
      if (sdk) {
        this.sdkLoader.next(sdk);
        clearInterval(interval);
      }

      if (counter >= 20) {
        console.log('PAZE SDK not loaded after 5 seconds');
        clearInterval(interval);
      }
    }, 250);
  }
}